// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qr2b3","badges":"styles_badges__3PD9Z"};